import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ObrasProjeto } from '../models/obras-projeto.model';
import { BaseService } from 'src/app/base/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObrasProjetoService extends BaseService<ObrasProjeto> {

  constructor(public http: HttpClient) {
    super(http);
  }

  // obras do entregável
  public getObrasList(id: number): Observable<ObrasProjeto[]> {
    return this.http.get<ObrasProjeto[]>(this.baseUrl + '/obras-list/' + id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/obras';
  }
}
